import AppRoute from "../routes/AppRouter";

function Content() {
  return (
    <main className="w-[90%] sm:w-[80%] lg:w-[70%] xl:max-w-[1200px] mx-auto">
      <AppRoute />
    </main>
  );
}

export default Content;
